import { Component, OnInit, Input } from '@angular/core';
@Component({
    selector   : 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls  : ['./accordion.component.scss']
})
export class AppAccordionComponent
{
    @Input() item: any;
    active: boolean;
    @Input() iconActive: boolean;
    @Input() check: boolean;
    @Input() key: any;
    constructor()
    {
        this.iconActive = false;
        this.active = false;
        this.check = false;
        this.key = '';
    }
    collapse(): void
    {
        this.active = !this.active;
    }
}
